const { getModifiedVars, getTheme } = require('components/theme')

const colors = {
  accent: '#FF9551',
  background: '#fafafa',
  border: '#D9D9D9',
  simpleBarBackground: '#99c4ee',
  simpleBarClickedBackground: 'rgba(80,153,222)',
  simpleBarNotClickedBackground: '#dce4ec',
  simpleBarSalaryBackground: '#68CEB7',
  white: '#FFFFFF',
}

const antdOverrides = {}

const modifiedVars = getModifiedVars({ antdOverrides })

const theme = getTheme({ antdOverrides, colors })

module.exports = {
  colors,
  modifiedVars,
  theme,
}
